import ClientPortal from '../../../plugins/axios'

export default {
    verifyACU(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/verifyAPE`,
            payload,
            { withCredentials: true }
        )
    },
    additionalClinics(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/additionalClinicAPE`,
            payload,
            { withCredentials: true }
        )
    },
    fetchRecentApproval(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/getACURecentApproval`,
            payload,
            { withCredentials: true }
        )
    },
    revalidateApproval(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/revalidateACUApproval`,
            payload,
            { withCredentials: true }
        )
    }
}

